import { resolve, singleton } from 'aurelia';
import { HttpClient } from './http-client';

// The latest log file's metadata and (possibly truncated) tail content as returned by
// GET /api/admin/latest-log. When no logs exist, fileName is null and content is empty.
export interface LatestLog {
  fileName: string | null;
  modifiedUtc: string | null;
  sizeBytes: number;
  content: string;
  truncated: boolean;
}

// Owns the admin Logs panel: shows the tail of the most recently modified file under the app's
// logs/ folder. Mirrors the other singleton admin services — shared state lives here and the panel
// binds to it directly. Read-only.
@singleton()
export class LogsAdminService {
  private readonly http: HttpClient = resolve(HttpClient);

  panelOpen: boolean = false;
  loading: boolean = false;
  error: string | null = null;
  log: LatestLog | null = null;

  async load(): Promise<void> {
    this.loading = true;
    this.error = null;
    try {
      const response = await this.http.get('/api/admin/latest-log');
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      this.log = await response.json();
    } catch (e: any) {
      this.error = `Could not load the latest log: ${e.message}`;
      this.log = null;
    } finally {
      this.loading = false;
    }
  }

  async openPanel(): Promise<void> {
    this.panelOpen = true;
    await this.load();
  }

  closePanel(): void {
    this.panelOpen = false;
    this.error = null;
  }
}
